const actTemplatesEditActions = {
  ACT_TEMPLATES_EDIT_INIT: 'ACT_TEMPLATES_EDIT_INIT',
  ACT_TEMPLATES_EDIT_SET: 'ACT_TEMPLATES_EDIT_SET',
  ACT_TEMPLATES_PROP_SET: 'ACT_TEMPLATES_PROP_SET',
  ACT_TEMPLATES_PROP_DELETE: 'ACT_TEMPLATES_PROP_DELETE',
  ACT_TEMPLATES_EXPRESSIONS_RESET: 'ACT_TEMPLATES_EXPRESSIONS_RESET'
};
export default actTemplatesEditActions;
